import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=1dfacb83&"
import script from "./not-found.vue?vue&type=script&lang=ts&"
export * from "./not-found.vue?vue&type=script&lang=ts&"
import style0 from "./not-found.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports